/**
 * @public
 */
export function hasDisplaySize(valueOrPredicate) {
    const predicate = typeof valueOrPredicate === "function"
        ? valueOrPredicate
        : (size) => valueOrPredicate === size;
    return (element) => {
        return predicate(element.displaySize());
    };
}
//# sourceMappingURL=has-display-size.js.map